import type { ProductsResponses as ApiResponses } from '@/types/externals/obbsApi/index';

export const useProduct = () => {
  const getProduct = async (code: string): Promise<ApiResponses.ProductResponse> => {
    const url: string = `/products/${code}`;
    const { data, error } = await useApiFetch<ApiResponses.ProductResponse>(url, {
      key: `product-${code}`,
    });

    if (error.value) {
      throw createError({
        statusCode: 404,
        statusMessage: 'API fetch error',
        message: `${error.value.title}`,
        fatal: true,
      });
    }

    return data.value;
  };

  return {
    getProduct,
  };
};
